// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1nNAi","label":"styles-module--label--13t-S","hours":"styles-module--hours--1CCVY","tooltip":"styles-module--tooltip--1jYJP"};